import { Button } from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/Dropdown";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import type { Tab } from "../PatientTabs";
import { PatientTab } from "./PatientTab";

export const PatientsMinimized = ({
  options,
}: {
  options: Tab[];
}) => {
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <div
          className="flex items-center justify-center h-full relative ml-[-1px]"
          data-testid="minimized-patients-trigger"
        >
          <Button
            variant="icon"
            className="w-6 h-6 absolute right-1 bg-white rounded-full hover:bg-neutral-100 shadow-lg"
            aria-label="minimized-patients-trigger"
          >
            <ChevronDown size={18} />
          </Button>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="p-0 border-none w-fit dark:bg-white"
        data-testid="minimized-patients"
      >
        {options?.map((tab) => (
          <PatientTab
            className="w-72"
            key={tab.patient.id + tab.encounter?.id}
            tab={tab}
            hideEOCTooltip={true}
            onSelected={() => setOpen(false)}
          />
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
